import { render, staticRenderFns } from "./GlobalSelecting.vue?vue&type=template&id=f4663760&scoped=true&"
import script from "./GlobalSelecting.vue?vue&type=script&lang=js&"
export * from "./GlobalSelecting.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSelecting.vue?vue&type=style&index=0&id=f4663760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4663760",
  null
  
)

export default component.exports